var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGymAndHomeIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 122,
    height: 64,
    viewBox: "0 0 122 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M32-16A32,32,0,0,0,64-48,32,32,0,0,0,32-80,32,32,0,0,0,0-48,32,32,0,0,0,32-16Z",
    fill: "#fed6e5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M-814,262.2H338V-557H-814Z",
    transform: "translate(814 557)",
    fill: "#fed6e5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    transform: "translate(-315 -2001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(315 2081)",
    opacity: 0.6,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009",
    transform: "translate(-651.2 -461.6)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M-5-85H67v72H-5Z",
    transform: "translate(652.2 462.6)",
    fill: "#fed6e5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018",
    transform: "translate(-2158.923 1251.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M2508.005,763.744,2492.117,779.8v18.818a.793.793,0,0,0,.793.793h29.363a.793.793,0,0,0,.793-.793V778.639S2508.005,763.248,2508.005,763.744Z",
    transform: "translate(-1.169 -0.76)",
    fill: "#fcbcdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M2526.707,779.667l-8.056-8.055v-9.127a.737.737,0,0,0-.737-.738h-3.136a.738.738,0,0,0-.738.738V767l-7.081-7.081a.776.776,0,0,0-1.073,0l-19.748,19.748a.738.738,0,0,0,0,1.043l2.218,2.217a.738.738,0,0,0,1.043,0l17.023-17.023,17.023,17.023a.738.738,0,0,0,1.043,0l2.217-2.217A.738.738,0,0,0,2526.707,779.667Z",
    fill: "#FA85BE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 10.051,
    height: 16.16,
    rx: 1.564,
    transform: "translate(2501.397 782.445)",
    fill: "#FA85BE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(373 2081)",
    opacity: 0.599,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(-651.2 -461.6)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M-5-85H67v72H-5Z",
    transform: "translate(652.2 462.6)",
    fill: "#fed6e5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(380.924 2020.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996",
    transform: "translate(0 11.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M1088.031,1543.685h-7.759v4.194h7.759a2.1,2.1,0,0,0,0-4.194Z",
    transform: "translate(-1042.04 -1543.685)",
    fill: "#FDC4DA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M765.577,1543.685H758.27a2.1,2.1,0,0,0,0,4.194h7.307Z",
    transform: "translate(-756.173 -1543.685)",
    fill: "#FDC4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 19.411,
    height: 4.194,
    transform: "translate(14.112 0)",
    fill: "#FDC4DA"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997",
    transform: "translate(4.518)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 6.37,
    height: 18.727,
    rx: 3.185,
    transform: "translate(0 3.765)",
    fill: "#FA85BE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 6.37,
    height: 18.727,
    rx: 3.185,
    transform: "translate(32.682 3.765)",
    fill: "#FA85BE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 6.37,
    height: 26.256,
    rx: 3.185,
    transform: "translate(23.937 0)",
    fill: "#FA85BE"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 6.37,
    height: 26.256,
    rx: 3.185,
    transform: "translate(8.717 0)",
    fill: "#FA85BE"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGymAndHomeIcons);
export default __webpack_public_path__ + "static/media/gym-and-home-icons.9783f807.svg";
export { ForwardRef as ReactComponent };